import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '../stores/authStore'
import { AppShell } from '../layouts/AppShell'

export const Route = createFileRoute('/_auth')({
  beforeLoad: () => {
    const isAuthenticated = useAuthStore.getState().isAuthenticated
    if (!isAuthenticated) {
      throw redirect({ to: '/login' })
    }
  },
  component: AppShell,
})
